import type { FC, ReactNode } from 'react';

import { useTranslation } from '@crehana/i18n';
import type { IconProps } from '@crehana/icons/types';

interface TableEmptyStateProps {
  body?: string;
  title?: string;
  button?: ReactNode;
  isSearch?: boolean;
  bottomLabel?: ReactNode;
  icon?: FC<React.PropsWithChildren<IconProps>>;
}

const TableEmptyState: FC<React.PropsWithChildren<TableEmptyStateProps>> = ({
  body,
  title,
  button,
  isSearch,
  bottomLabel,
  icon: MyIcon,
}) => {
  const { t } = useTranslation();

  const emptyTitle = isSearch ? t('TABLE_EMPTY_STATE_1') : title;
  const emptyLabel = isSearch ? t('TABLE_EMPTY_STATE_2') : body;

  return (
    <>
      <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-py-16 tw-px-1.6">
        <div className="tw-w-5.6 tw-h-5.6 tw-rounded-full tw-bg-neutral-light-300 tw-flex tw-justify-center tw-items-center">
          {MyIcon && <MyIcon size={24} className="tw-text-neutral-light-600" />}
        </div>
        <p className="tw-font-subtitle5 tw-mb-0.4 tw-mt-1.2">{emptyTitle}</p>
        <p className="tw-font-body4 tw-text-neutral-light-700 tw-mb-2.4">
          {emptyLabel}
        </p>
        {button}
      </div>
      {bottomLabel && (
        <div className="tw-flex tw-items-center tw-justify-center tw-pb-2">
          <p className="tw-font-body4 tw-text-neutral-light-700">
            {bottomLabel}
          </p>
        </div>
      )}
    </>
  );
};

export default TableEmptyState;
